import React from "react";
import ReactDom from "react-dom";
import { Button } from "reactstrap";
import { getPreguntas, getPreguntasTecnicas } from "../requests/req_perfil";
import VideoRecorder from "../record/video-recorder";
import { notifica } from "../requests/utils";
import { isMobile, isMobileSafari, isSafari } from "react-device-detect";
import IndexRecord from "../components/ImageRecord/IndexRecord";
import Vios from "../record/video-ios";

export default class FrmRecordVideo extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      preguntas: [],
      preguntaActual: {
        imgInterVideo: {
          src: "",
          flag: false,
          number: 1,
        },
      },
      tipo: "",
      val: false,
      crrtime: 0,
      timeLimit: 90000,
      statusMessage: {
        message: "",
        flag: true,
      },
    };

    this.cargaRecorder = this.cargaRecorder.bind(this);
    this.establecepreguntas = this.establecepreguntas.bind(this);
    this.resultado = this.resultado.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.tipo === "RH") {
      getPreguntas((e) => this.establecepreguntas(e));
      this.setState({ tipo: "RH" });
    } else if (this.props.tipo === "TC") {
      getPreguntasTecnicas(
        (a) => this.establecepreguntas(a),
        this.props.idSolicitud
      );
      this.setState({ tipo: "TC" });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  establecepreguntas(datos) {
    const { PUBLIC_URL } = process.env;
    const tmpData = datos === null ? [] : datos;
    const array = tmpData.map((data, index) => {
      return {
        ...data,
        status: true,
        imgInterVideo:
          index + 1 <= 3
            ? data.idPrestador === 2
              ? isMobile
                ? { flag: true, src: "", number: index + 1 }
                : {
                    flag: false,
                    src:
                      index + 1 === 3
                        ? `${PUBLIC_URL}/images/InterPregTec/vertical${
                            index + 1
                          }.svg`
                        : `${PUBLIC_URL}/images/InterPregTec/vertical${
                            index + 1
                          }.jpg`,
                  }
              : {
                  flag: false,
                  src: `${PUBLIC_URL}/images/loading.gif`,
                }
            : {
                flag: false,
                src: `${PUBLIC_URL}/images/loading.gif`,
              },
      };
    });
    this.setState({ preguntas: array }, () => {
      const ftr = document.querySelector(".App-Mod-Ftr.modal-footer");
      ftr.classList.add("Hide_All");
      const countPreugntas = this.state.preguntas.length;
      if (countPreugntas > 0) {
        this.setState({
          statusMessage: {
            message: "Cuentas con " + countPreugntas + " preguntas pendientes.",
            flag: true,
          },
        });
      } else {
        this.setState({
          statusMessage: {
            message: "¡Felicidades!, No cuentas con preguntas pendientes.",
            flag: false,
          },
        });
      }
    });
  }
  propsvid(e) {
    var vd = document.querySelector("video");
    vd.pause();
  }
  propsvidPlay(e) {
    var vd = document.querySelector("video");
    this.setState({ timeLimit: this.state.crrtime });
    vd.currentTime = this.state.crrtime;
    vd.play();
  }
  cargaRecorder() {
    let result = {};
    this.state.preguntas.some((datos) => {
      if (datos.status) {
        result = datos;
        return true;
      } else {
        return false;
      }
    });
    let count = 0;
    this.state.preguntas.map((i) => {
      if (i.status) {
        return count++;
      }
      return null;
    });

    this.setState({
      preguntaActual: { ...result },
      statusMessage: {
        message: "Cuentas con " + count + " preguntas pendientes.",
        flag: false,
      },
    });

    if (Object.keys(result).length === 0) {
      notifica("info", "Has finalizado la carga de videos.", "¡Excelente!");
      document.getElementById("cncmdl").click();
    }

    var btn = document.getElementById("btn_grdvideo_sigue");
    btn.classList.add("Hide_Half");
    var dvvr = document.getElementById("dv_grabavideo");

    if (isMobileSafari || isSafari)
      ReactDom.render(<Vios id="vdo" timeLimit={this.state.timeLimit} />, dvvr);
    else
      ReactDom.render(
        <VideoRecorder id="vdo" timeLimit={this.state.timeLimit} />,
        dvvr
      );
  }
  resultado() {
    let array = [];
    this.state.preguntas.map((datos) => {
      if (datos.idPregunta === this.state.preguntaActual.idPregunta) {
        return array.push({ ...this.state.preguntaActual, status: false });
      } else {
        return array.push(datos);
      }
    });

    var dvvr = document.getElementById("dv_grabavideo");
    ReactDom.unmountComponentAtNode(dvvr);
    document.getElementById("btnModalClose").hidden = false;
    this.setState(
      {
        preguntas: array,
      },
      this.cargaRecorder
    );
  }
  render() {
    const mystyle = {
      height: "100%",
      width: "100%",
    };
    const ParentImg = {
      marginLeft: "-14px",
      marginRight: "-14px",
    };
    return (
      <div className="ARC_Rcrd_dv">
        <div id="loading_recorder" style={ParentImg} className="display_none">
          {Object.keys(this.state.preguntaActual).length === 0 &&
          this.state.preguntaActual.constructor === Object ? (
            ""
          ) : this.state.preguntaActual.imgInterVideo.flag ? (
            <IndexRecord
              name={this.state.preguntaActual.imgInterVideo.number}
            />
          ) : (
            <img
              style={mystyle}
              id="img_loading"
              src={this.state.preguntaActual.imgInterVideo.src}
              alt="Smiley face"
            />
          )}
        </div>
        <div id="dv_preguntas">
          <div>
            <label>{this.state.statusMessage.message}</label>
            {this.state.statusMessage.flag ? (
              <Button outline color="danger" onClick={this.cargaRecorder}>
                Comenzar a grabar respuestas.
              </Button>
            ) : null}
            <br />
            <label
              className="lbl_prgnts_rcrd"
              id="lbl_pregunta_tipo"
              tipo={this.state.tipo}
            ></label>
            <label
              className="lbl_prgnts_rcrd"
              id="lbl_pregunta_sol"
              sol={this.props.idSolicitud}
            />
            <label
              className="lbl_prgnts_rcrd"
              id="prestadora"
              prestadora={this.state.preguntas?.length > 0 ? this.state.preguntas[0].idPrestador : null}
            />
            <label
              className="lbl_prgnts_rcrd"
              id="lbl_pregunta_p_video"
              idPregunta={
                this.state.preguntaActual.idPregunta
                  ? this.state.preguntaActual.idPregunta
                  : null
              }
            >
              {this.state.preguntaActual.descripcion
                ? this.state.preguntaActual.descripcion
                : ""}
            </label>
          </div>
        </div>
        <div id="dv_grabavideo" />
        <div id="dv_cntrls" className="">
          <Button
            outline
            color="info"
            className="Btn_Vd_PP Hide_Half"
            id="btn_grdvideo_sigue"
            onClick={this.resultado}
          >
            Guardar y continuar
            <img
              src={process.env.PUBLIC_URL + "/images/icon_save_next.png"}
              alt=" "
            />
          </Button>
        </div>
      </div>
    );
  }
}
